import omit from 'lodash/omit';

import { SentryHelper } from 'src/common/sentry';
import AnalyticsUtils from 'src/common/helpers/analyticsUtils';


const identifyHubUser = (user: any) => {
  var _hsq = (window._hsq = window._hsq || []);
_hsq.push([
  'identify',
  {
    name: user.name,
    email: user.email,
    last_organization: omit(user.last_organization),
    created_at: AnalyticsUtils.getTimeFromDate(user.created_at && user.created_at),
  }
]);
window._hsq = _hsq;

};

const trackHubPage = () => {
  var _hsq = (window._hsq = window._hsq || []);
  _hsq.push(['trackPageView']);
  window._hsq = _hsq;
};

// identifyCustomerUser and trackCustomerPage were here, sending the same two
// things to Customer.io that identifyHubUser and trackHubPage send to HubSpot.
// Removed with the rest of the Customer.io migration: the profiles they built
// fed campaigns that are now Draft, Stopped or Archived, and segments the
// dashboard marks Unused with zero people. HubSpot keeps doing both jobs
// unchanged. See docs/CUSTOMER_IO.md.

const identifyUser = (user: any) => {
  // Segment identify

  let segErr=false;
  try{
    identifyHubUser(user)
  }
  catch(err: any){
    segErr=true
  }

  SentryHelper.setUser(user.email);
};

const trackPage = () => {
  // Segment page
  let segErr=false;
  try{
    trackHubPage()
  }
  catch(err: any){
    segErr=true
  }
};

const AnalyticsHelper = {
  identifyUser,
  trackPage,
};

export default AnalyticsHelper;
